<h1>Aprovar carga horária efetiva</h1>
<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <fieldset fxFlex="100%">
      <legend>Aluno</legend>
      <div fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput value="{{ data?.nome }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput value="{{ data?.cpf }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Programa</mat-label>
            <input matInput value="{{ data?.programa }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Curso</mat-label>
            <input matInput value="{{ data?.curso }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input matInput value="{{ data?.campus }}" readonly="readonly" />
          </mat-form-field>
        </div>
      </div>
    </fieldset>
    <fieldset fxFlex="100%">
      <legend>Disciplina</legend>
      <div fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Disciplina</mat-label>
            <input matInput value="{{ data?.nomeDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Código</mat-label>
            <input matInput value="{{ data?.codigoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Semestre</mat-label>
            <input matInput value="{{ data?.semestre }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Duração</mat-label>
            <input matInput value="{{ data?.duracao }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Carga horária</mat-label>
            <input matInput value="{{ data?.cargaHoraria }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Departamento</mat-label>
            <input matInput value="{{ data?.departamentoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input matInput value="{{ data?.campusDisciplina }} - {{ data?.siglaDisciplina }}" readonly="readonly" />
          </mat-form-field>
        </div>
      </div>
    </fieldset>
    <fieldset fxFlex="100%">
      <legend>Plano</legend>
      <mat-card class="info">
        <p>Preencha a carga horária para cada item.</p>
        <ul>
          <li>A soma da carga horária lançada não pode ser maior que a carga horária total da disciplina.</li>
          <li><b>Item 16</b>, o valor não pode ser maior que 20% do total da carga horária da disciplina.</li>
        </ul>
      </mat-card>
      <app-alerta-carga-horaria-sisgrad></app-alerta-carga-horaria-sisgrad>
      <br />
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="idItemPlano">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell data-label="#" *matCellDef="let row">{{ row.idItemPlano }}</td>
        </ng-container>
        <ng-container matColumnDef="descricaoItemPlano">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
          <td mat-cell data-label="Descrição" *matCellDef="let row">{{ row.descricaoItemPlano }}</td>
        </ng-container>
        <ng-container matColumnDef="cargaHorariaPrevista">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Carga horária prevista</th>
          <td mat-cell data-label="Carga horária prevista" *matCellDef="let row">
            <div class="bordered">
              {{ row.cargaHorariaPrevista }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="cargaHorariaEfetiva">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Carga horária efetiva</th>
          <td mat-cell data-label="Carga horária efetiva" *matCellDef="let row">
            <mat-form-field appearance="outline">
              <input [(ngModel)]="row.cargaHorariaEfetiva" matInput mask="0*" min="0" max="99" maxlength="2" />
            </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      </table>
    </fieldset>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayoutAlign="space-between center">
      <button mat-raised-button color="primary" (click)="gravar()"><mat-icon>save</mat-icon> Gravar</button>
      <button mat-stroked-button color="warn" routerLink="/docente/aprovar-carga-horaria">
        <mat-icon>close</mat-icon> Voltar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
